import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const IconList = ({ className, theme, size, withBackground, children }) => (
  <ul className={cx(styles.wrapper, className)}>
    {React.Children.map(children, child => {
      if (!child) return null

      return React.cloneElement(child, { theme, size, withBackground })
    })}
  </ul>
)

IconList.propTypes = {
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small', 'extraSmall', 'medium', 'large']),
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

IconList.defaultProps = {
  theme: 'primary',
  size: 'default',
}

export default IconList
